<template>
  <v-container fluid
    class="pa-0">
    <splitpanes-layout :hidePreview="this.$route.params.jobId === undefined">
      <template v-slot:list>
        <v-container fluid class="pa-0 parent_conatiner">

          <ListToolbar v-model="FilteredJobList" :inputlist="JobList" :filterablefields="filterablefields"
            :sortablefields="sortablefields" :objectName="'servicesystem.common_objects.job.jobs'">

            <template v-slot:toolbar-content-center>
              <v-checkbox v-model="includeCompleted" :label="$t('servicesystem.common_objects.job.include_completed')"
                hide-details @change="getJobs()">
              </v-checkbox>
            </template>
          </ListToolbar>

          <QScroll :list="FilteredJobList" :unfilteredcount="JobList ? JobList.length : 0" :loading="loading"
            :height="'calc(100vh - ' + (isPcBool ? 142 : 134) + 'px)'">
            <template v-slot:list-item="{ item }">
              <job-li :jobItem="item" :multiselectmode="/*multiselectmode*/ false" :showStatus="true"
                :selected="$route.params.jobId === item.Id">
              </job-li>
            </template>

            <template v-slot:empty-list>
              <empty-page :icon="'mdi-briefcase-remove'"
                :title="$t('servicesystem.common_objects.fallbackterms.no_my_jobs')"
                :message="$t('servicesystem.common_objects.fallbackterms.found_no_jobs_my')" class="ignoreodd">
              </empty-page>
            </template>
          </QScroll>

        </v-container>
      </template>

      <template v-slot:preview>
        <component :is="'PreviewJob'" />
      </template>

    </splitpanes-layout>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import JobLi from "@/components/ListItems/JobListItem/JobListItem.vue";
import QScroll from "@/components/Sections/Containers/QScroll.vue";
import EmptyPage from "@/components/Sections/EmptyPage.vue";
import PreviewJob from "@/components/Sections/Panes/PreviewJob.vue";
import ListToolbar from "@/views/admin/machines/ListToolbar.vue";
import SplitpanesLayout from "@/views/layouts/PreviewableList.vue";
//import PreviewJob2 from "@/components/Sections/Panes/PreviewJob2.vue";

export default {
  components: {
    SplitpanesLayout,
    JobLi,
    EmptyPage,
    QScroll,
    ListToolbar,
    PreviewJob,
    //PreviewJob2,
  },
  mixins: [clientAPI],

  data() {
    return {
      showFilterMenu: false,
      loading: false,
      JobList: [],
      FilteredJobList: [],

      sortablefields: [
        { key: "OrderId", type: "int", displayString: "servicesystem.common_objects.order.order_id" },
        { key: "StatusId", type: "int", displayString: "servicesystem.common_objects.job.status" },
        { key: "JobPriorityDueAfterHours", type: "int", displayString: "servicesystem.common_objects.job.priority" },
        { key: "JobTypeName", type: "string", displayString: "servicesystem.common_objects.job.type" },
        //{ key: "CreatedDate", type: "datetime", displayString: "servicesystem.common_objects.job.created" },
      ],

      filterablefields: [
        {
          key: "JobTypeName",
          displayString: "servicesystem.common_objects.job.type",
          value: [],
          textkey: "Name",
          valuekey: "Name",
          optionsgetter: "LookUpStore/JobTypeList",
        },

        {
          key: "JobPriorityId",
          displayString: "servicesystem.common_objects.job.priority",
          value: [],
          textkey: "Name",
          valuekey: "Id",
          optionsgetter: "LookUpStore/JobPriorityList",
        },
      ],

      includeCompleted: false,
    };
  },

  mounted() {
    this.getJobs();
  },

  methods: {
    getJobs() {
      this.loading = true;
      this.getJobListFromFilter({ SearchWord: this.$route.query.q, ItemsPerPage: 100 })
        .then((response) => {
          this.FilteredJobList = response.Content;
          this.JobList = response.Content;
        })
        .catch((exception) => console.log(exception))
        .finally(() => (this.loading = false));
    },
  },

  computed: {
    JobPreviewPaneMode() {
      return this.$store.getters["prefrences/Prefrence"]("JobPreviewPaneMode");
    },
  },

  watch: {
    "$route.query.q"() {
      this.getJobs();
    },
  },
};
</script>


<style lang="scss" scoped>
.minitoolbar {
  position: sticky;
  width: 100%;
  z-index: 4;
  box-shadow: 0px 1px 5px var(--v-header-darken2) !important;
}

.parent_conatiner {
  position: relative;
  display: flex;
  flex-flow: column;
  max-height: 100%;
}

::v-deep .v-input--checkbox .v-label {
  font-size: 13px !important;
  margin-left: 4px;
}
</style>